import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { find } from 'lodash';
import { compose } from 'recompose';

import { MODAL_EDIT_FILE_NAME } from 'modules/messageSystem/constants/modalCodes';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import ModalEditFileName from './ModalEditFileName';

const MAX_FILENAME_LENGTH = 50;

const onModalDismiss = state => fileName => {
  const uploadModal = find(state.messageSystem.modals.queue, ({ typeId }) => typeId === MODAL_EDIT_FILE_NAME);
  if (uploadModal) {
    uploadModal.bodyValues.comment = fileName;
  }
};

function mapStateToProps(state, ownProps) {
  const {
    bodyValues: {
      thumbnail: fileSrc,
      mimeType: fileType,
      comment: fileName,
    },
  } = ownProps;

  return {
    fileSrc,
    fileType,
    onModalDismiss: onModalDismiss(state),
    fileName,
    maxLength: MAX_FILENAME_LENGTH,
  };
}

export default compose(
  connect(mapStateToProps),
  withEscHandler,
  injectIntl,
)(ModalEditFileName);
